function initToneShowcase() {
  const carousels = document.querySelectorAll('.tone-showcase__carousel-wrapper');
  
  carousels.forEach(wrapper => {
    if (wrapper.dataset.initialized === 'true') return;
    wrapper.dataset.initialized = 'true';

    const track = wrapper.querySelector('.tone-showcase__track');
    if (!track) return;
    
    const slides = Array.from(track.querySelectorAll('.tone-showcase__slide'));
    if (slides.length === 0) return;
    
    let activeIndex = Math.floor(slides.length / 2);
    
    function isMobileSize() {
      return window.innerWidth <= 767;
    }
    
    function updateSlides() {
      const isMobile = isMobileSize();
      const offsetStep = isMobile ? 65 : 140; 
      const scaleStep = isMobile ? 0.1 : 0.12; 
      const N = slides.length;
      
      slides.forEach((slide, index) => {
        let diff = ((index - activeIndex) % N + N) % N;
        if (diff > Math.floor(N / 2)) diff -= N;
        const absDiff = Math.abs(diff);
        
        if (absDiff > 3) {
          slide.style.opacity = '0';
          slide.style.pointerEvents = 'none';
          slide.style.transform = `translateX(${Math.sign(diff) * offsetStep * 3}px) scale(${1 - scaleStep * 3})`;
          slide.classList.remove('is-active');
          return;
        }
        
        const translateX = diff * offsetStep;
        const scale = 1 - (absDiff * scaleStep);
        const zIndex = slides.length - absDiff;
        const opacity = 1; // All visible cards are 100% opaque
        
        slide.style.transform = `translateX(${translateX}px) scale(${scale})`;
        slide.style.zIndex = zIndex;
        slide.style.opacity = opacity;
        slide.style.pointerEvents = 'auto'; 
        
        if (absDiff === 0) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }
    
    function stopGlobalAudio() {
      if (window.toneShowcaseAudio && !window.toneShowcaseAudio.paused) {
        window.toneShowcaseAudio.pause();
        window.toneShowcaseAudio.currentTime = 0;
      }
      if (window.toneShowcasePlayingBtn) {
        window.toneShowcasePlayingBtn.classList.remove('is-playing');
      }
      window.toneShowcaseAudio = null;
      window.toneShowcasePlayingBtn = null;
    }
    
    function goToSlide(index) {
      const N = slides.length;
      if (N === 0) return;
      let newIndex = ((index % N) + N) % N;
      if (newIndex !== activeIndex) {
        stopGlobalAudio();
      }
      activeIndex = newIndex;
      updateSlides();
    }
    
    slides.forEach((slide, index) => {
      const newSlide = slide.cloneNode(true);
      slide.parentNode.replaceChild(newSlide, slide);
    });
    
    const freshSlides = Array.from(track.querySelectorAll('.tone-showcase__slide'));
    
    freshSlides.forEach((slide, index) => {
      slide.addEventListener('click', (e) => {
        if (index === activeIndex) return; 
        e.preventDefault(); 
        goToSlide(index);
      });
      
      const btn = slide.querySelector('.tone-showcase__play-btn');
      if (btn) {
        btn.addEventListener('click', (e) => {
          e.stopPropagation(); 
          if (btn.classList.contains('is-disabled')) return;
          if (index !== activeIndex) return; 
          
          const audioUrl = btn.getAttribute('data-audio');
          if (!audioUrl) return;
          
          if (window.toneShowcasePlayingBtn === btn && window.toneShowcaseAudio) {
            if (window.toneShowcaseAudio.paused) {
              const playPromise = window.toneShowcaseAudio.play();
              if (playPromise !== undefined) {
                playPromise.then(() => {
                  btn.classList.add('is-playing');
                }).catch(err => {
                  console.error('Audio playback failed:', err);
                  btn.classList.remove('is-playing');
                });
              } else {
                btn.classList.add('is-playing');
              }
            } else {
              window.toneShowcaseAudio.pause();
              btn.classList.remove('is-playing');
            }
          } else {
            stopGlobalAudio();
            
            window.toneShowcaseAudio = new Audio(audioUrl);
            window.toneShowcasePlayingBtn = btn;
            
            const playPromise = window.toneShowcaseAudio.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                btn.classList.add('is-playing');
              }).catch(err => {
                console.error('Audio playback failed:', err);
                btn.classList.remove('is-playing');
                window.toneShowcaseAudio = null;
                window.toneShowcasePlayingBtn = null;
              });
            } else {
              btn.classList.add('is-playing');
            }
            
            window.toneShowcaseAudio.addEventListener('ended', () => {
              btn.classList.remove('is-playing');
              if (window.toneShowcasePlayingBtn === btn) {
                window.toneShowcaseAudio = null;
                window.toneShowcasePlayingBtn = null;
              }
            });
            window.toneShowcaseAudio.addEventListener('error', () => {
              btn.classList.remove('is-playing');
              if (window.toneShowcasePlayingBtn === btn) {
                window.toneShowcaseAudio = null;
                window.toneShowcasePlayingBtn = null;
              }
            });
          }
        });
      }
    });
    
    slides.length = 0;
    freshSlides.forEach(s => slides.push(s));
    
    let startX = 0;
    let isDragging = false;
    let dragDistance = 0;
    
    function handleTouchStart(e) {
      if (e.target.closest('.tone-showcase__play-btn')) return; 
      startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
      isDragging = true;
      dragDistance = 0;
      track.style.cursor = 'grabbing';
    }
    
    function handleTouchMove(e) {
      if (!isDragging) return;
      const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
      dragDistance = startX - currentX;
      if (Math.abs(dragDistance) > 10 && e.cancelable) {
        e.preventDefault();
      }
    }
    
    function handleTouchEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      
      if (Math.abs(dragDistance) > 50) { 
        if (dragDistance > 0) {
          goToSlide(activeIndex + 1);
        } else {
          goToSlide(activeIndex - 1);
        }
      }
    }
    
    track.addEventListener('mousedown', handleTouchStart);
    window.addEventListener('mousemove', handleTouchMove, { passive: false });
    window.addEventListener('mouseup', handleTouchEnd);
    
    track.addEventListener('touchstart', handleTouchStart, {passive: true});
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleTouchEnd);
    
    window.addEventListener('resize', () => {
      requestAnimationFrame(updateSlides);
    });
    
    updateSlides();
  });
}

document.addEventListener('DOMContentLoaded', initToneShowcase);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.tone-showcase-section')) {
      // Force stop any global audio on editor re-render
      if (window.toneShowcaseAudio) {
        window.toneShowcaseAudio.pause();
        window.toneShowcaseAudio = null;
      }
      if (window.toneShowcasePlayingBtn) {
        window.toneShowcasePlayingBtn.classList.remove('is-playing');
        window.toneShowcasePlayingBtn = null;
      }

      const wrapper = e.target.querySelector('.tone-showcase__carousel-wrapper');
      if (wrapper) wrapper.dataset.initialized = 'false';
      initToneShowcase();
    }
  });
  
  document.addEventListener('shopify:block:select', function(e) {
    if (e.target.closest('.tone-showcase-section')) {
      const wrapper = e.target.closest('.tone-showcase-section').querySelector('.tone-showcase__carousel-wrapper');
      if (wrapper) wrapper.dataset.initialized = 'false';
      initToneShowcase();
    }
  });
}
